import { OOG, OOGPosition, StowagePositionDto, UnitListDto } from '@tom-ui/planning/app/api'
import {
  BaplieParseResult,
  VesselVisitBaplieParseResult,
} from '@tom-ui/planning/pages/Order/stores/OrderListUploadParsingStore'
import { IOrderDto } from '@tom-ui/planning/pages/Order/stores/OrderListUploadViewStoreV2'
import {
  BaplieParseResultOrderDto,
  BaplieParseResultVesselDto,
  OutOfGauge,
  StowagePosition,
} from 'modules/integration/src/app/api'
import { dataParserService } from 'modules/integration/src/services'

export const mapOOGInformation = (oogFromBaplie: OutOfGauge): OOG[] => {
  const oogList: OOG[] = []

  if (oogFromBaplie.Front)
    oogList.push({ direction: OOGPosition.Front, measurement: oogFromBaplie.Front })
  if (oogFromBaplie.Rear)
    oogList.push({ direction: OOGPosition.Rear, measurement: oogFromBaplie.Rear })
  if (oogFromBaplie.Left)
    oogList.push({ direction: OOGPosition.Left, measurement: oogFromBaplie.Left })
  if (oogFromBaplie.Right)
    oogList.push({ direction: OOGPosition.Right, measurement: oogFromBaplie.Right })
  if (oogFromBaplie.Top)
    oogList.push({ direction: OOGPosition.Top, measurement: oogFromBaplie.Top })

  return oogList
}

export const mapStowagePosition = (
  stowagePosition?: StowagePosition,
): StowagePositionDto | undefined => {
  if (!stowagePosition) return

  return {
    bay: stowagePosition.Bay,
    row: stowagePosition.Row,
    tier: stowagePosition.Tier,
  }
}

export const mapVesselVisitData = (
  vesselVisitData: BaplieParseResultVesselDto,
): VesselVisitBaplieParseResult => {
  return {
    vesselName: vesselVisitData.Name ?? undefined,
    imoNumber: vesselVisitData.IsoNumber ?? undefined,
    callSign: vesselVisitData.CallSign ?? undefined,
  }
}

export const mapToIOrderDto = (order: BaplieParseResultOrderDto): IOrderDto => {
  const dto: UnitListDto = {
    containerNumber: order.ContainerNumber ?? '',
    referenceNumber: order.ReferenceNumber,
    portOfDischarge: order.PortOfDischarge,
    portOfLoading: order.PortOfLoading,
    isEmpty: order.IsEmpty,
    isoCode: order.IsoCode,
    grossWeight: order.GrossWeight,
    vgm: order.VGM,
    billOfLading: order.BillOfLading,
    placeOfOrigin: order.PlaceOfOrigin,
    finalDestination: order.FinalDestination,
    inlandDestination: order.InlandDestination,
    outOfGauge: order.OutOfGauge ? mapOOGInformation(order.OutOfGauge) : undefined,
    operator: order.Operator,
    temperature: order.Temperature,
    stowagePosition: mapStowagePosition(order.StowagePosition),
    operationalInstructions: order.OperationalInstructions,
    imoClasses: order.ImoClasses ?? [],
  }

  return { ...dto, railTrack: undefined }
}

export const parseBaplie: (file: File) => Promise<BaplieParseResult> = async (file: File) => {
  const parseResult = await dataParserService.parseBaplie(file)
  const { Vessel, Orders, Errors } = parseResult

  const orders: IOrderDto[] = Orders?.map(mapToIOrderDto) ?? []
  const vesselVisit = Vessel ? mapVesselVisitData(Vessel) : undefined

  return { vesselVisit, orders, errors: Errors ?? [] }
}
